import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.contract.sections.billingAddress.title',
    defaultMessage: 'Billing address',
    description: 'title of the contract section',
  },
  edit: {
    title: {
      id: 'pages.contract.sections.billingAddress.edit.title',
      defaultMessage: 'Edit billing address',
      description: 'title of the contract section',
    },
    button: {
      id: 'actions.edit',
      defaultMessage: 'Edit',
      description: 'label of the edit button',
    },
  },
  feedback: {
    billingAddressSaved: {
      id: 'pages.contract.sections.billingAddress.feedback.billingAddressSaved',
      defaultMessage: 'Billing address saved',
      description: 'billing address saved feedback message',
    },
    billingAddressNotSaved: {
      id: 'pages.contract.sections.billingAddress.feedback.billingAddressNotSaved',
      defaultMessage: 'Could not save billing address',
      description: 'billing address not saved feedback message',
    },
  },
};

export default defineMessages(translations);
